<template>
  <v-container
   fluid
   class="pl-0 pr-0"
   style="max-width: 450px;"
  >
    <!-- <GecomMobile v-if="permiteAcao({ path: '/relatorios/gecom-home/' })" /> -->
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line
import { errorSnackbar } from '@/core/service/utils'
import storage from '@/core/service/localStorage'

// KbnCanvas.share()
export default {
  name: 'Home',
  components: {
    // GecomMobile: () => import('@/views/relatorios/gecomMobile')
  },

  data: () => ({
  }),
  
  async mounted() {
    // this.getUrlKibana().catch(e => errorSnackbar(e.error))
    const user = storage.get('auth-token')
    const path = '/afiliados/afiliados-painel/'
    await this.getAcl().catch((err)=> { console.log(err)})
      
    if(!user.jsonFlags.isAdminMaster && user.jsonFlags.affiliateId && this.permiteAcao({ path: '/afiliados/afiliados-painel/' })) {
       this.$router.push(path).catch((err) => {
        console.log(err)
       })
    }
  },

  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('home', ['urlkibana']),
  },

  methods: {
    ...mapActions('home', ['getUrlKibana']),
    ...mapActions('roles', ['getAcl']),
  }
}
</script>

<style lang="scss" scoped>
  .iframe-kb {
    min-height: calc(100vh - 112px + 24px);
    border: none;
    margin: -24px;
    width: calc(100% + 50px);
  }
</style>